// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"246":"5958a4c7","453":"7a25eeba"}[chunkId] + ".chunk.js";
};